import extractDefinitions from "../extractDefinitions";
// I have no idea what this is meant to be as it's used as a component elsewhere
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const Text = ({ children, ...rest }) => {
    return {
        text: extractDefinitions(children),
        ...rest
    };
};
export default Text;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVGV4dC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb21wb25lbnRzL1RleHQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sa0JBQWtCLE1BQU0sdUJBQXVCLENBQUM7QUFHdkQsZ0ZBQWdGO0FBQ2hGLDhEQUE4RDtBQUM5RCxNQUFNLElBQUksR0FBRyxDQUFDLEVBQUUsUUFBUSxFQUFFLEdBQUcsSUFBSSxFQUFrQixFQUFPLEVBQUU7SUFDMUQsT0FBTztRQUNMLElBQUksRUFBRSxrQkFBa0IsQ0FBQyxRQUFRLENBQUM7UUFDbEMsR0FBRyxJQUFJO0tBQ1IsQ0FBQztBQUNKLENBQUMsQ0FBQztBQUVGLGVBQWUsSUFBSSxDQUFDIn0=